import { render, staticRenderFns } from "./IssueCreate.vue?vue&type=template&id=3520760d&scoped=true"
import script from "./IssueCreate.vue?vue&type=script&lang=js"
export * from "./IssueCreate.vue?vue&type=script&lang=js"
import style0 from "./IssueCreate.vue?vue&type=style&index=0&id=3520760d&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520760d",
  null
  
)

export default component.exports